import { typeOf } from "../tool/func";
import { appFunction, registerCallback } from "./unit";
import { isIos } from "../tool/assert";

/**
 * @description 获取版本号
 * @version all
 * @system Android/Ios
 * @resolve {String} 版本号
 */
export const mddGetVersionName = () =>
  appFunction("mddGetVersionName", "mddGetVersionNameCallback");

/**
 * @description 获取用户信息
 * @version all
 * @system Android/Ios
 * @hack 由于3.9.50版本ios 错误的将获取用户信息回调方法写成loginCallback，而且需要用户登录了才会执行，所以做特殊处理
 * @resolve {Object} 用户信息
 * {
 *  status:[Number] 0已登录 1未登录(特别注意安卓是Number,ios是String)
 *  deviceId:[String] 设备id
 *  gender:[Number] 性别 0保密 1男 2女
 *  iconurl:[String] 用户头像
 *  id:[String] 用户id(通常叫uuid)
 *  isVodVip:[Number] 0不是vip 1是vip
 *  mobile:[String] 用户手机号
 *  nickname:[String] 用户昵称
 *  reserveFieId1:[String] 储备字段（暂无用）
 *  reserveFieId2:[String] 储备字段（暂无用）
 *  reserveFieId3:[String] 储备字段（暂无用）
 *  visitorStatus:[Number] 是否游客状态：0 否、1 是,版本：4.0.79+
 * }
 */
export const mddGetUserInfo = async () => {
  if (isIos && (await mddGetVersionName()) === "3.9.50") {
    return appFunction("mddGetUserInfo", "loginCallback");
  } else {
    return appFunction("mddGetUserInfo", "infoCallback").then((res) => {
      // 历史问题ios返回的status为字符串，而Android为数字
      res && (res.status = Number(res.status));
      return res;
    });
  }
};

/**
 * @description 登录（全屏）
 * @version 3.9.5+
 * @system Android/Ios
 * @resolve {Object} 用户信息（mddGetUserInfo）
 * 注意：登录回调在Android 可以全局通知（即通知所有webview）,而ios只通知当前webview
 */
export const mddLogin = () => appFunction("mddLogin", "loginCallback");

/**
 * @description 登录（半屏）
 * @version 3.9.5+
 * @system Android/Ios
 * @resolve {Object} 用户信息（mddGetUserInfo）
 * 注意：登录回调在Android 可以全局通知（即通知所有webview）,而ios只通知当前webview
 */
export const mddLoginDialog = () =>
  appFunction("mddLoginDialog", "loginCallback");

/**
 * @description 获取直播间信息
 * @version 3.9.5+
 * @system Android/Ios
 * @resolve 返回用户信息 [Object] 属性如下：
 *  anchorMemberUuid:[String] 主播id
 *  liveUuid:[Number] 直播间id
 */
export const mddLiveInfo = () =>
  appFunction("mddLiveInfo", "mddLiveInfoCallback");

/**
 * @description 直播间送礼物
 * @version 3.9.5+
 * @system Android/Ios
 * @params [Object] 参数对象属性如下
 * num [Number] 送礼数
 * liveGiftModel [Object] 这个对象信息一般通过后端接口请求返回
 * liveUuid [Number] 直播间ID
 * deductWay [Number] 扣除途径 0背包扣除(默认值) 1付费扣除
 * batchUuid [String] 批次ID（唯一识别码Uuid 生成可使用本库的tool模块的createUuid方法）
 * isSupportContinuity [Number] 是否支持连击动作 0不支持(默认值)、1支持
 * 若支持连击：需要h5处理连击交互和数据组装礼物模型里的批次ID和所送礼物在批次
 * 从0开始的位置batchUuid、positionOfBatch，以及连击动作完成告知客户端
 * 即调用mdd同步方法mddSendGiftContinuityEnd通知客户端送礼结束
 *
 * @resolve 返回送礼状态信息
 * status 状态 [Number] 0:成功 -1:失败
 * liveUuid 直播间ID [Number]
 * batchUuid 批次ID [String]
 * deductWay 扣除方式 [Number]
 */
export const mddSendLiveRoomGift = (options) => {
  const params = isIos ? options : JSON.stringify(options);
  return appFunction(
    "sendLiveRoomGift",
    "sendLiveRoomGiftCallback",
    params
  ).then((res) => {
    // 为兼容3.9.80 ~ 3.9.81安卓客户端写错状态字段，错误使用了state，1：成功：0：失败，
    // 正确的为：status：状态 0:成功 -1:失败
    res.status = res.status === 0 || res.state === 1 ? 0 : -1;
  });
};

/**
 * @description 设置回退动作
 * @version 3.9.5+
 * @params {options} [String] 0(默认，按路由回退) 1：直接退出 2:拦截返回，并执行onGoBackCallback回调
 * @resolve 只有在 type 为2的时候才会有resolve，并无返回值
 */
export const mddSetGoBack = (options) => {
  if (options == null) options = 0;
  const params = { type: options };
  const FormatParams = isIos ? params : JSON.stringify(params);
  console.log(params, "mddSetGoBack");
  return appFunction("setGoBack", "onGoBackCallback", FormatParams);
};

/**
 * @description 桥接请求（通过app请求返回给H5数据），调试需要通过查看app的日志信息
 * @version 4.0.50+
 * @param options [Object] 参数
 *        options.key: 桥接接口标识（又后端提供）必填
 *        options.params: 请求参数（对应的后端接口参数）选填
 *        options.h5_sessionId:String 传时间搓，来区分response唯一性 必填
 *
 * @resolve res [Object] 返回结果
 *          res.h5_sessionId:String（为了保证请求唯一）
 *          res.msgType:状态 0成功，-1网络错误，非0失败
 *          res.status:应答状态
 *          res.time:时间戳
 *          res.signType:签名方式
 *          res.data :应答内容
 */
export const mddBridgeRequest = (options) => {
  if (options == null) options = {};
  const params = isIos ? options : JSON.stringify(options);
  return appFunction("mddBridgeRequest", "mddBridgeRequestCallback", params);
};

/**
 * @description 激励广告回调
 * @version 4.0.75+
 * @param options [Object] 参数 必填
 *        options.ubixAdSeatUuid [string] UBIX广告位ID，4.6.00+版本
 *        options.msAdxdataAdSeatUuid [string] 美数的广告位ID 4.4.35+版本，【注意，ios用的字段依然是toponAdSeatUuid，传值需传美数的广告位ID】
 *        options.toponAdSeatUuid [string] Topon的广告位ID
 *        options.key [string] 业务数据key,每个项目唯一
 * @param options[event] [Function] 选填 激励广告事件类型（生命周期，因为会多次触发同一回调函数，使用pomise处理不方便，所以直接使用传统回调模式）
 *          options.onLoaded: 广告加载成功回调
 *          options.onFailed: 广告加载失败回调
 *          options.onPlayStart: 广告开始播放回调
 *          options.onPlayEnd: 广告播放结束回调
 *          options.onPlayFailed: 广告播放失败回调
 *          options.onClosed: 广告关闭回调
 *          options.onPlayClicked: 广告点击
 *          options.onReward: 达成激励条件
 *
 * @result data [Object] 回调结果
 *          data.toponAdSeatUuid [string] Topon的广告位ID
 *          data.key [string] 业务数据key,每个项目唯一
 *          data.message [string] 事件消息
 data.event 激励广告事件类型
 */
export const mddRewardVideo = (options) => {
  if (options == null) options = {};
  const params = isIos ? options : JSON.stringify(options);
  window["rewardVideoEventCallback"] = (data) => {
    const { event } = data || {};
    typeOf(options[event], "function") && options[event](data);
  };
  appFunction("showRewardVideo", undefined, params);
};

export const mddRewardVideo2 = (options) => {
  if (options == null) options = {};
  let params = {};
  for (let k in options) {
    if (!typeOf(options[k], "function")) {
      params[k] = options[k];
    }
  }
  params = isIos ? params : JSON.stringify(params);
  window["rewardVideoEventCallback"] = (data) => {
    const { event } = data || {};
    typeOf(options[event], "function") && options[event](data);
  };
  appFunction("showRewardVideo", undefined, params);
};

/**
 * @description 分享链接
 * @version all
 * @param options.data [Object] 参数 必填 描述
 *        options.data.imageUrls [Array] 图片数组
 *        options.data.webUrl [string] 分享链接
 *        options.data.iconUrl [string] 分享图标链接
 *        options.data.title [string] 分享标题
 *        options.data.desc [string] 分享描述
 *        options.share [function] 分享回调，isPromise=false的形式情况下会执行
 *        options.cancle [function] 取消分享回调，isPromise=false的形式情况下会执行
 *
 * @param isPromise [Boolean] 参数 必填 是否是promise模式
 *
 *
 * @result data [Object] promise回调结果
 *         data.share [promise]  status：状态0:成功 -1:失败, platform：分享平台（QQ、QZONE、WEIXIN、WEIXIN_CIRCLE、SINA）
 *         data.cancle [promise] 返回data type 1，点击取消按钮 2，点击弹框外取消
 */
export const mddShare = (options, isPromise = false) => {
  if (options == null) options = {};
  const data = options.data || {};
  const params = isIos ? data : JSON.stringify(data);
  if (isPromise) {
    const callbackMap = {
      share: "shareCallback",
      cancle: "mddShareDialogDismissCallback",
    };
    Object.keys(callbackMap).forEach((key) => {
      callbackMap[key] = appFunction(undefined, callbackMap[key], params);
    });
    appFunction("mddShare", undefined, params);
    return callbackMap;
  } else {
    window["shareCallback"] = (data) => {
      typeOf(options["share"], "function") && options["share"](data);
    };
    window["mddShareDialogDismissCallback"] = (data) => {
      typeOf(options["cancle"], "function") && options["cancle"](data);
    };
    appFunction("mddShare", undefined, params);
  }
};

/**
 * @description 分享图片
 * @version all
 * @param options.data [Object] 参数 必填 描述
 *        options.data.imageUrls [Array] 图片数组
 *        options.data.webUrl [string] 分享链接
 *        options.data.iconUrl [string] 分享图标链接
 *        options.data.title [string] 分享标题
 *        options.data.desc [string] 分享描述
 *        options.share [function] 分享回调，isPromise=false的形式情况下会执行
 *        options.cancle [function] 取消分享回调，isPromise=false的形式情况下会执行
 *
 * @param isPromise [Boolean] 参数 必填 是否是promise模式
 *
 *
 * @result data [Object] promise回调结果
 *         data.share [promise]  status：状态0:成功 -1:失败, platform：分享平台（QQ、QZONE、WEIXIN、WEIXIN_CIRCLE、SINA）
 *         data.cancle [promise] 返回data type 1，点击取消按钮 2，点击弹框外取消
 */
export const mddShareImage = (options, isPromise = false) => {
  if (options == null) options = {};
  const data = options.data || {};
  const params = isIos ? data : JSON.stringify(data);
  if (isPromise) {
    const callbackMap = {
      share: "shareCallback",
      cancle: "mddShareDialogDismissCallback",
    };
    Object.keys(callbackMap).forEach((key) => {
      callbackMap[key] = appFunction(undefined, callbackMap[key], params);
    });
    appFunction("mddShareImage", undefined, params);
    return callbackMap;
  } else {
    window["shareCallback"] = (data) => {
      typeOf(options["share"], "function") && options["share"](data);
    };
    window["mddShareDialogDismissCallback"] = (data) => {
      typeOf(options["cancle"], "function") && options["cancle"](data);
    };
    appFunction("mddShareImage", undefined, params);
  }
};

/**
 * @description 获取页面内参数
 * @version 4.0.80+
 * @params {keys} [Array] 业务数据key数组,例如{keys:["vodUuid"]}
 * @resolve 无论是否匹配到值，都需要回调mddGetAppInnerDataCallback给H5
 */
export const mddGetAppInnerData = (options) => {
  if (options == null) options = {};
  const params = isIos ? options : JSON.stringify(options);
  return appFunction(
    "mddGetAppInnerData",
    "mddGetAppInnerDataCallback",
    params
  );
};

/**
 * @description 监听浏览器页面显示或隐藏
 * @version all
 * @system Android/Ios
 * @param {cbFunc} [Function]  回调方法
 * @return {visible} [String] 回调参数： "1": 显示 "0": 隐藏
 */
export const mddOnWebPageVisiableChange = (cbFunc) => {
  registerCallback("onWebPageVisiableChange", cbFunc);
};
